import { c as o, cB as n, insideModal as d, insidePopover as a, asModal as t, cM as e, cE as r } from "./highrise314.mjs";
const c = o([n("card", `
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 display: flex;
 flex-direction: column;
 width: 100%;
 box-sizing: border-box;
 position: relative;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 color: var(--n-text-color);
 word-break: break-word;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [t({
  background: "var(--n-color-modal)"
}), e("hoverable", [o("&:hover", "box-shadow: var(--n-box-shadow);")]), e("content-segmented", [o(">", [r("content", {
  paddingTop: "var(--n-padding-bottom)"
})])]), e("content-soft-segmented", [o(">", [r("content", `
 margin: 0 var(--n-padding-left);
 padding: var(--n-padding-bottom) 0;
 `)])]), e("footer-segmented", [o(">", [r("footer", {
  paddingTop: "var(--n-padding-bottom)"
})])]), e("footer-soft-segmented", [o(">", [r("footer", `
 padding: var(--n-padding-bottom) 0;
 margin: 0 var(--n-padding-left);
 `)])]), o(">", [n("card-header", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 padding:
 var(--n-padding-top)
 var(--n-padding-left)
 var(--n-padding-bottom)
 var(--n-padding-left);
 `, [r("main", `
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 min-width: 0;
 color: var(--n-title-text-color);
 `), r("extra", `
 display: flex;
 align-items: center;
 font-size: var(--n-font-size);
 font-weight: 400;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), r("close", `
 margin: 0 0 0 8px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), r("action", `
 box-sizing: border-box;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 background-clip: padding-box;
 background-color: var(--n-action-color);
 `), r("content", "flex: 1; min-width: 0;"), r("content, footer", `
 box-sizing: border-box;
 padding: 0 var(--n-padding-left) var(--n-padding-bottom) var(--n-padding-left);
 font-size: var(--n-font-size);
 `, [o("&:first-child", {
  paddingTop: "var(--n-padding-bottom)"
})]), r("action", `
 background-color: var(--n-action-color);
 padding: var(--n-padding-bottom) var(--n-padding-left);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `)]), n("card-cover", `
 overflow: hidden;
 width: 100%;
 border-radius: var(--n-border-radius) var(--n-border-radius) 0 0;
 `, [o("img", `
 display: block;
 width: 100%;
 `)]), e("bordered", `
 border: 1px solid var(--n-border-color);
 `, [o("&:target", "border-color: var(--n-color-target);")]), e("action-segmented", [o(">", [r("action", [o("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), e("content-segmented, content-soft-segmented", [o(">", [r("content", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [o("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), e("footer-segmented, footer-soft-segmented", [o(">", [r("footer", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [o("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), e("embedded", `
 background-color: var(--n-color-embedded);
 `)]), d(n("card", `
 background: var(--n-color-modal);
 `, [e("embedded", `
 background-color: var(--n-color-embedded-modal);
 `)])), a(n("card", `
 background: var(--n-color-popover);
 `, [e("embedded", `
 background-color: var(--n-color-embedded-popover);
 `)]))]);
export {
  c as default
};
